export default {
	init() {
		function run() {
			const layoutSelector = '.layout.cards.cards3';
			const layouts = document.querySelectorAll(layoutSelector);
			if (!layouts.length) return;

			let resizeListenerBound = false;

			function equalizeOneLayout(layoutEl) {
				const copyEls = Array.from(layoutEl.querySelectorAll('.cards-items .card-copy'));
				if (!copyEls.length) return;

				// Reset first so we can measure natural height.
				copyEls.forEach((copyEl) => {
					copyEl.style.height = '';
				});

				let maxHeight = 0;
				copyEls.forEach((copyEl) => {
					maxHeight = Math.max(maxHeight, copyEl.getBoundingClientRect().height);
				});

				if (!maxHeight) return;
				copyEls.forEach((copyEl) => {
					copyEl.style.height = `${Math.ceil(maxHeight)}px`;
				});
			}

			function scheduleEqualize(layoutEl) {
				requestAnimationFrame(() => equalizeOneLayout(layoutEl));
			}

			function initOne(layoutEl) {
				if (layoutEl.dataset.cards3CopyEqualized === '1') return;
				layoutEl.dataset.cards3CopyEqualized = '1';

				scheduleEqualize(layoutEl);

				const imgs = layoutEl.querySelectorAll('img');
				imgs.forEach((img) => {
					if (img.complete) return;
					img.addEventListener('load', () => scheduleEqualize(layoutEl), { once: true });
				});

				if (!resizeListenerBound) {
					resizeListenerBound = true;
					window.addEventListener('resize', () => {
						document
							.querySelectorAll(layoutSelector)
							.forEach((el) => scheduleEqualize(el));
					});
				}

				if (window.ResizeObserver) {
					const ro = new ResizeObserver(() => scheduleEqualize(layoutEl));
					ro.observe(layoutEl);
				}
			}

			layouts.forEach((layoutEl) => initOne(layoutEl));
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', run, { once: true });
		} else {
			run();
		}
	},
};
